<template>
  <div class="container container--small">
    <section class="section-web section-web--form section-web--alt">
      <div
        class="section__actions d-flex justify-content-between align-items-center"
      >
        <h5><i class="fas fa-user"></i>My Profile</h5>
      </div>
      <!-- /.section__actions -->
      <div
        class="section__content section__content--grey"
        v-if="profile.length"
      >
        <div class="section__inner">
          <form autocomplete="off" action="?" method="post">
            <div class="form-frame">
              <div class="form-row">
                <div class="form-group">
                  <label for="field-shalach" class="form__label">
                    Display As*
                    <p style="margin-bottom: 0; font-size: 12px">
                      ( this is how your name will appear on the cards/scrolls
                      of the people you send to )
                    </p>
                  </label>

                  <textarea
                    name="field-shalach"
                    id="field-shalach"
                    cols="30"
                    class="field"
                    rows="3"
                    v-model="profile[0].displayName"
                    v-bind:class="{ error: !profile[0].displayName }"
                    v-bind:maxlength="settings[0].displayNameLimit"
                  ></textarea>

                  <span class="form__note"
                    >(Max {{ settings[0].displayNameLimit }} characters)</span
                  >
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form__row -->
              <div class="form-row">
                <div class="form-group">
                  <label for="field-title" class="form__label">Title</label>

                  <input
                    type="text"
                    class="field"
                    id="field-title"
                    placeholder
                    v-model="profile[0].title"
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row form-row--cols">
                <!-- /.form-group -->
                <div class="form-group col-md-6">
                  <label for="field-name-1" class="form__label"
                    >First Name
                  </label>

                  <input
                    type="text"
                    class="field"
                    id="field-name-1"
                    placeholder=""
                    v-model="profile[0].memberFirstName"
                    autocomplete="new-member-fname"
                  />
                </div>
                <!-- /.form-group -->

                <div class="form-group col-md-6">
                  <label for="field-lname-1" class="form__label"
                    >Last Name
                    <i class="fas fa-question-circle">
                      <md-tooltip md-direction="right" class="info-tooltip"
                        >If the details on this page are not your own, you may
                        be logged into the wrong account. Please contact your
                        fundraiser coordinator, or email
                        <!-- <a href="mailto: support@happypurim.com"
                          >support@happypurim.com</a
                        > -->
                        <a href="mailto: support@happypurim.com"
                          >support@happypurim.com</a
                        >
                      </md-tooltip></i
                    >
                  </label>

                  <input
                    type="text"
                    class="field"
                    id="field-lname-1"
                    placeholder=""
                    v-model="profile[0].memberLastName"
                    disabled
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form__row -->

              <div class="form-row form-row--cols">
                <!-- /.form-group -->

                <div class="form-group col-md-6">
                  <label for="field-spouse-2" class="form__label"
                    >First Name of
                    <span v-if="settings[0].organizationId !== 689"
                      >Spouse</span
                    >
                    <span v-if="settings[0].organizationId === 689"
                      >Significant Other</span
                    >
                  </label>

                  <input
                    type="text"
                    class="field"
                    id="field-spouse-2"
                    placeholder=""
                    v-model="profile[0].spouseFirstName"
                    autocomplete="new-spouse-name"
                  />
                </div>
                <!-- /.form-group -->

                <div class="form-group col-md-6">
                  <label for="field-lname-2" class="form__label"
                    >Last Name of
                    <span v-if="settings[0].organizationId !== 689"
                      >Spouse</span
                    >
                    <span v-if="settings[0].organizationId === 689"
                      >Significant Other</span
                    >
                  </label>

                  <input
                    type="text"
                    class="field"
                    id="field-lname-2"
                    placeholder=""
                    v-model="profile[0].spouseLastName"
                    autocomplete="new-spouse-lastname"
                  />
                </div>
                <!-- /.form-group -->

                <span class="form__note">(if different)</span>
              </div>
              <!-- /.form__row -->

              <div class="form-row">
                <div class="form-group">
                  <label for="field-address-1" class="form__label"
                    >Address</label
                  >

                  <input
                    type="text"
                    class="field"
                    id="field-address-1"
                    placeholder=""
                    v-model="profile[0].memberAddress1"
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row">
                <div class="form-group">
                  <label for="field-address-2" class="form__label"
                    >Address 2 / Apt</label
                  >

                  <input
                    type="text"
                    class="field"
                    id="field-address-2"
                    placeholder=""
                    v-model="profile[0].memberAddress2"
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row form-row--cols">
                <div class="form-group col-md-5">
                  <label for="field-city" class="form__label">City</label>

                  <input
                    type="text"
                    class="field"
                    id="field-city"
                    placeholder=""
                    v-model="profile[0].memberCity"
                  />
                </div>
                <!-- /.form-group -->

                <div class="form-group col-md-2">
                  <label for="field-state" class="form__label">State</label>
                  <input
                    type="text "
                    class="form-control form-control-md"
                    id="field-state"
                    v-model="profile[0].memberState"
                  />

                  <!-- <select
                    class="form-control form-control-md"
                    id="field-state"
                    v-model="profile[0].memberState"
                    v-bind:class="{'error': !profile[0].memberState}"
                  >
                    <option
                      :value="state.abbreviation"
                      v-for="state in states"
                      :key="state.abbreviation"
                    >
                      {{ state.abbreviation }}
                    </option>
                  </select> -->
                </div>
                <!-- /.form-group -->

                <div class="form-group col-md-5">
                  <label for="field-postcode" class="form__label"
                    >Postal Code</label
                  >

                  <input
                    type="text"
                    class="field"
                    id="field-postcode"
                    placeholder=""
                    v-model="profile[0].memberZip"
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row form-row--cols">
                <div class="form-group col-md-5">
                  <label for="field-phone" class="form__label">Phone</label>

                  <input
                    type="tel"
                    class="field"
                    id="field-phone"
                    placeholder=""
                    v-model="profile[0].memberPhone"
                  />
                </div>
                <!-- /.form-group -->

                <div class="form-group col-md-7">
                  <label for="field-email" class="form__label">
                    Email*
                    <!-- <span class="email_note"
                      >( receipts will be sent here )</span
                    > -->
                  </label>

                  <input
                    type="email"
                    class="field"
                    id="field-email"
                    placeholder=""
                    v-model="profile[0].memberPrimaryEmail"
                    v-bind:class="{ error: !profile[0].memberPrimaryEmail }"
                  />
                </div>
                <!-- /.form-group -->
              </div>
              <div class="form-row form-row--cols">
                <div class="form-group col-md-12">
                  <label for="field-email2" class="form__label">
                    Secondary Email
                  </label>

                  <input
                    type="email"
                    class="field"
                    id="field-email2"
                    placeholder=""
                    v-model="profile[0].memberSecondaryEmail"
                  />
                </div>
              </div>
              <div
                class="form-row form-row--cols"
                v-if="
                  custom[1].hasDoorman.indexOf(settings[0].organizationId) > -1
                "
              >
                <div class="form-group col-md-12">
                  <label
                    for="field-foorman"
                    class="form__label"
                    style="width: 100%"
                  >
                    My Building Has a 24 Hour Doorman:
                  </label>

                  <md-radio v-model="profile[0].hasDoorman" :value="true"
                    >Yes</md-radio
                  >
                  <md-radio v-model="profile[0].hasDoorman" :value="false"
                    >No</md-radio
                  >
                </div>
              </div>

              <!-- memberSecondaryEmail -->
              <div class="form-row" v-if="settings[0].displayChildren">
                <div class="form-group">
                  <label for="field-delivery" class="form__label"
                    >Children's Names</label
                  >

                  <textarea
                    name="field-delivery"
                    id="field-delivery"
                    cols="30"
                    class="field"
                    rows="3"
                    v-model="profile[0].children"
                  ></textarea>
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row" v-if="settings[0].showShippingInstructions">
                <div class="form-group">
                  <label
                    for="field-delivery"
                    class="form__label"
                    v-if="!settings[0].showShippingInstructionsTitle"
                  >
                    Special Delivery Instructions
                  </label>
                  <label
                    for="field-delivery"
                    class="form__label"
                    v-if="settings[0].showShippingInstructionsTitle"
                  >
                    {{ settings[0].showShippingInstructionsTitle }}
                  </label>

                  <textarea
                    name="field-delivery"
                    id="field-delivery"
                    cols="30"
                    class="field"
                    rows="3"
                    v-model="profile[0].notes"
                  ></textarea>
                </div>
                <!-- /.form-group -->
              </div>
              <!-- /.form-row -->

              <div class="form-row">
                <ul
                  class="list-checks list-checks--block"
                  v-if="settings[0].alternateDeliveryAddress"
                >
                  <li>
                    <div class="custom-control">
                      <md-checkbox
                        id="delivery1"
                        v-model="profile[0].useAlternateDelivery"
                        >{{
                          profile[0].alternateDeliveryAddressPrompt
                        }}</md-checkbox
                      >
                    </div>
                  </li>
                </ul>
                <!-- /.list-checks list-checks-/-block -->
              </div>
              <div
                class="alternative-wrap"
                v-if="
                  profile[0].useAlternateDelivery &&
                    settings[0].alternateDeliveryAddress
                "
              >
                <div class="form-row">
                  <div class="form-group">
                    <label for="field-address-2" class="form__label"
                      >Name</label
                    >

                    <input
                      type="text"
                      class="field"
                      id="field-address-2"
                      placeholder
                      v-model="profile[0].altName"
                    />
                  </div>
                  <!-- /.form-group -->
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="field-address-4" class="form__label"
                      >Address</label
                    >
                    <input
                      type="text"
                      class="field"
                      id="field-address-4"
                      placeholder
                      v-model="profile[0].altAddress"
                    />
                  </div>
                  <!-- /.form-group -->
                </div>
                <!-- /.form-row -->
                <div class="form-row">
                  <div class="form-group">
                    <label for="field-apt" class="form__label"
                      >Apt/Suite/Room</label
                    >
                    <input
                      type="text"
                      class="field"
                      id="field-apt"
                      placeholder
                      v-model="profile[0].altAddress2"
                    />
                  </div>
                  <!-- /.form-group -->
                </div>
                <!-- /.form-row -->

                <div class="form-row">
                  <div class="form-group">
                    <label for="field-city" class="form__label">City</label>
                    <input
                      type="text"
                      class="field"
                      id="field-city"
                      placeholder
                      v-model="profile[0].altCity"
                    />
                  </div>
                  <!-- /.form-group -->
                </div>
                <!-- /.form-row -->
                <div class="form-row p-b-1">
                  <label for="field-state" class="form__label">State</label>
                  <input
                    type="text"
                    v-model="profile[0].altState"
                    class="form-control form-control-md"
                    id="field-state"
                  />

                  <!-- <select
                    class="form-control form-control-md"
                    id="field-state"
                    v-model="profile[0].altState"
                  >
                    <option value="">Select</option>
                    <option
                      :value="state.abbreviation"
                      v-for="state in states"
                      :key="state.abbreviation"
                    >
                      {{ state.abbreviation }}
                    </option>
                  </select> -->
                  <!-- /.form-group -->
                </div>
                <!-- /.form-row -->
                <div class="form-row alt-last p-t-1">
                  <div class="form-group">
                    <label for="field-code" class="form__label"
                      >Postal Code</label
                    >
                    <input
                      type="text"
                      class="field"
                      id="field-code"
                      placeholder
                      v-model="profile[0].altPostalCode"
                    />
                  </div>
                  <!-- /.form-group -->
                </div>
                <!-- /.form-row -->
              </div>
              <!-- /.alternative-wrap -->

              <div class="form-row">
                <ul
                  class="list-checks list-checks--block"
                  v-if="
                    profileOptions.length ||
                      profileCustomOptions.length ||
                      settings[0].donateBasketOption
                  "
                >
                  <li>
                    <div
                      class="custom-control custom-checkbox custom-checkbox--alt"
                      v-if="
                        settings[0].donateBasketOption &&
                          settings[0].donateBasketOptionText
                      "
                    >
                      <md-checkbox v-model="profile[0].donateBasketOption">{{
                        settings[0].donateBasketOptionText
                      }}</md-checkbox>
                    </div>

                    <div
                      class="custom-control custom-checkbox custom-checkbox--alt"
                      v-for="item in profileOptions"
                      :key="item.optId"
                    >
                      <md-checkbox v-model="item.joinValue" class="custom">
                        {{ item.optText }}</md-checkbox
                      >
                    </div>
                    <div v-for="item in profileCustomOptions" :key="item.id">
                      <label style="font-size: 0.8em"
                        >{{ item.label }}
                        <span v-if="item.required" class="required"
                          >*</span
                        ></label
                      >
                      <select
                        v-model="item.selValue"
                        class="form-control form-control-md"
                      >
                        <option value="" disabled>Select</option>
                        <option
                          v-for="opt in item.data"
                          :key="opt.optText"
                          :value="opt.optText"
                        >
                          {{ opt.optText }}
                        </option>
                      </select>
                    </div>
                  </li>
                  <li class="required" style="font-size: 0.8em">
                    *fields required
                  </li>
                </ul>
                <!-- /.list-checks list-checks-/-block -->
              </div>
              <!-- /.form-row -->
              <div class="form__actions text-center">
                <md-button class="btn-grey" @click="resetProfile()"
                  >Reset</md-button
                >
                <md-button
                  href
                  class="btn-pink"
                  :disabled="disableSave"
                  @click="
                    saveProfile(profile, profileOptions, profileCustomOptions)
                  "
                >
                  Save &amp; Continue
                  <i class="ico-arrow-right"></i>
                </md-button>
              </div>
              <!-- /.form__actions -->
            </div>
            <!-- /.form -->
          </form>
        </div>
        <!-- /.section__inner -->
      </div>
      <!-- /.section__content -->
    </section>
    <!-- /.section-web -->
  </div>
  <!-- /.container container-/-large -->
</template>
<script>
import json from "../assets/states.json";
export default {
  name: "ProfilePage",
  data: function() {
    return {
      states: json,
    };
  },
  computed: {
    lastYear() {
      return this.$store.state.lastYear;
    },
    disableSave() {
      let val = false;

      if (!this.profile[0].displayName || !this.profile[0].memberPrimaryEmail) {
        val = true;
      }

      return val;
    },
    custom() {
      return this.$store.state.custom;
    },
    settings() {
      return this.$store.state.settings;
    },
    profile: {
      get: function() {
        // not all organizations have doorman, so ids are defined in store
        if (
          this.$store.state.custom[1].hasDoorman.indexOf(
            this.settings[0].organizationId,
          ) > -1 &&
          this.$store.state.userProfile[0].hasDoorman == null
        ) {
          this.$store.state.userProfile[0].hasDoorman = false;
        }
        return this.$store.state.userProfile;
      },
      set: function() {
        let copy = JSON.parse(localStorage.getItem("profile"));
        this.profile[0].displayName = copy[0].displayName;
        this.profile[0].memberFirstName = copy[0].memberFirstName;
        this.profile[0].memberLastName = copy[0].memberLastName;
        this.profile[0].title = copy[0].title;
        this.profile[0].spouseFirstName = copy[0].spouseFirstName;
        this.profile[0].spouseLastName = copy[0].spouseLastName;
        this.profile[0].memberAddress1 = copy[0].memberAddress1;
        this.profile[0].memberAddress2 = copy[0].memberAddress2;
        this.profile[0].memberCity = copy[0].memberCity;
        this.profile[0].memberState = copy[0].memberState;
        this.profile[0].memberZip = copy[0].memberZip;
        this.profile[0].memberPhone = copy[0].memberPhone;
        this.profile[0].memberPrimaryEmail = copy[0].memberPrimaryEmail;
        this.profile[0].memberSecondaryEmail = copy[0].memberSecondaryEmail;
        this.profile[0].children = copy[0].children;
        this.profile[0].notes = copy[0].notes;
        this.profile[0].useAlternateDelivery = copy[0].useAlternateDelivery;
        this.profile[0].altName = copy[0].altName;
        this.profile[0].altAddress = copy[0].altAddress;
        this.profile[0].altAddress2 = copy[0].altAddress2;
        this.profile[0].altCity = copy[0].altCity;
        this.profile[0].altState = copy[0].altState;
        this.profile[0].altPostalCode = copy[0].altPostalCode;
        this.profile[0].reciprocity = copy[0].reciprocity;
      },
    },
    profileOptions: {
      get: function() {
        return this.$store.state.profileOptions;
      },
      set: function() {
        let copy = JSON.parse(localStorage.getItem("profileOptions"));
        for (let i = 0; i < this.profileOptions.length; i++) {
          this.profileOptions[i].joinValue = copy[i].joinValue;
        }
      },
    },
    profileCustomOptions: {
      get: function() {
        return this.$store.state.profileCustomOptions;
      },
      set: function() {
        let copy = JSON.parse(localStorage.getItem("profileCustomOptions"));

        for (let i = 0; i < copy.length; i++) {
          this.profileCustomOptions[i].selValue = copy[i].selValue;
        }
      },
    },
  },
  methods: {
    resetProfile: function() {
      this.profileOptions = [];
      this.profileCustomOptions = [];
      this.profile = [];
    },
    checkIfMembersSelected: function(data) {
      let val = false;
      for (let i = 0; i < data.length; i++) {
        if (data[i].selected && !data[i].paid) {
          val = true;
          return val;
        }
      }
      return val;
    },
    checkIfNotPaid: function(data) {
      let val = false;
      for (let i = 0; i < data.length; i++) {
        if (data[i].paid) {
          val = true;
          return val;
        }
      }

      return val;
    },

    saveProfile: async function(data, profileOptions, profileCustomOptions) {
      this.$store.state.userProfile[0].confirmed = 1;
      await this.$store.dispatch("updateUserProfile", data);
      for (let i = 0; i < this.profileOptions.length; i++) {
        let item = {
          optId: this.profileOptions[i].optId,
          joinValue: this.profileOptions[i].joinValue,
        };
        await this.$store.dispatch("updateProfileOptions", item);
      }
      if (profileCustomOptions.length) {
        for (let i = 0; i < profileCustomOptions.length; i++) {
          let payload = {};
          payload.optId = profileCustomOptions[i].id;
          payload.OptValue = profileCustomOptions[i].selValue;
          await this.$store.dispatch("updateCustomProfileOptions", payload);
        }
      }
      // if not not last year orders screen and no promo screen, go straigt to list selections
      if (
        !this.settings[0].displayLastYearsOrderIntro &&
        !this.settings[0].displayPromotionsScreen
      ) {
        this.$router.push("/content/list").catch((error) => {
          if (error.name != "NavigationDuplicated") {
            throw error;
          }
        });
      } else if (
        this.settings[0].displayLastYearsOrderIntro &&
        this.lastYear.length
      ) {
        let sel = this.checkIfMembersSelected(this.$store.state.list);
        let paid = this.checkIfNotPaid(this.$store.state.list);
        //  check if there is smth in the cart already (members) if no, go to oreder history if yes to promo page if is enabled
        if (!sel && !paid && this.settings[0].displayLastYearsOrders) {
          this.$router.push("/content/orderhistory").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        } else {
          if (!this.settings[0].displayPromotionsScreen) {
            this.$router.push("/content/list").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          } else {
            //  this is custom details promotion as a screen,
            this.$router.push("/content/promotionscreen").catch((error) => {
              if (error.name != "NavigationDuplicated") {
                throw error;
              }
            });
          }
        }
      } else if (
        !this.settings[0].displayLastYearsOrderIntro ||
        !this.lastYear.length
      ) {
        if (!this.settings[0].displayPromotionsScreen) {
          this.$router.push("/content/list").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
        } else {
          this.$router.push("/content/promotionscreen").catch((error) => {
            if (error.name != "NavigationDuplicated") {
              throw error;
            }
          });
          //  this is custom details promotion as a screen,
        }
      }

      // /content/list
    },
  },
  async created() {
    window.scrollTo(0, 0);
    await this.$store.dispatch("getProfileOptions");
    await this.$store.dispatch("getProfileCustomOptions");

    // let tagArr = document.getElementsByTagName("input");
    // for (let i = 0; i < tagArr.length; i++) {
    //   tagArr[i].autocomplete = "off";
    // }
  },
  mounted() {},
};
</script>
<style>
.custom label.md-checkbox-label {
  cursor: pointer;
  height: auto !important;
}
.md-checkbox .md-checkbox-label {
  height: auto !important;
}
.email-note {
  font-size: 0.8em;
}
.alt-last {
  padding-bottom: 2em;
  border-bottom: 1px solid #d8d8d8;
  margin-bottom: 2em;
}
.btn-pink,
.btn-grey {
  padding: 1em !important;
  min-height: 50px;
  text-transform: capitalize !important;
}
.required {
  color: red;
}
input[disabled],
textarea[disabled],
select[disabled] {
  cursor: not-allowed !important;
  background: #ededed;
}
.md-tooltip {
  font-size: 12px !important;
}
.mat-tooltip.tooltip {
  background-color: darkblue;
  font-size: 12px;
}
.form-frame .form__label {
  margin-bottom: 0 !important;
  padding-left: 0 !important;
  color: var(--app-color-primary) !important;
  font-weight: 600 !important;
  font-size: 15px !important;
}
.btn-pink[disabled] {
  background-color: var(--app-color-secondary) !important;
  cursor: not-allowed !important;
}
.error {
  border-color: red !important;
}
.section-web--form .section__actions h5 {
  font-size: 23px !important;
}
.fa-user {
  padding-right: 1em;
}
::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #d6d6d6;
}
:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #d6d6d6;
  opacity: 1;
}
::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #d6d6d6;
  opacity: 1;
}
:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #d6d6d6;
}
::-ms-input-placeholder {
  /* Microsoft Edge */
  color: #d6d6d6;
}

::placeholder {
  /* Most modern browsers support this now. */
  color: #d6d6d6;
}
.md-checkbox.md-theme-default.md-checked .md-ripple {
  color: var(--app-color-primary) !important;
}
.md-checkbox.md-theme-default.md-checked .md-checkbox-container {
  background-color: var(--app-color-primary) !important;
  border-color: var(--app-color-primary) !important;
}
.fa-question-circle {
  color: var(--app-color-primary) !important;
}
</style>
